const API_KEY = process.env.REACT_APP_ANTHROPIC_API_KEY;

export async function callClaude(systemPrompt, messages) {
  if (!API_KEY) {
    throw new Error('Walang API key! I-add mo sa .env.local file ang REACT_APP_ANTHROPIC_API_KEY.');
  }

  const response = await fetch('https://api.anthropic.com/v1/messages', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY,
      'anthropic-version': '2023-06-01',
      'anthropic-dangerous-direct-browser-access': 'true'
    },
    body: JSON.stringify({
      model: 'claude-sonnet-4-20250514',
      max_tokens: 300,
      system: systemPrompt,
      messages
    })
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.error?.message || 'API error ' + response.status);
  }

  const data = await response.json();
  return data.content?.[0]?.text || '';
}

export const BATTLE_MODES = {
  banat: {
    label: 'Banat Battle',
    emoji: '💬',
    desc: 'Trade witty comebacks. The sharpest banat wins!',
    topics: [
      'Jollibee vs McDo — which one actually wins?',
      'Heart or brain — which is better at picking a partner?',
      'Manila vs Cebu — which is the better city to live in?',
      'Money vs love — which one do you actually need more?',
      'Solo life vs barkada life — which is more fun?'
    ]
  },
  tawad: {
    label: 'Tawad Wars',
    emoji: '🛒',
    desc: 'Haggle like you\'re at Divisoria. Best deal wins!',
    topics: [
      'Haggle for a second-hand iPhone at Quiapo!',
      'Convince the seller to lower the price of a ref with a small scratch!',
      'Negotiate the best deal on a second-hand motorcycle!'
    ]
  },
  kwento: {
    label: "Kwentuhan Ko 'To",
    emoji: '📺',
    desc: 'Co-write a teleserye drama. Most dramatic twist wins!',
    topics: [
      'Two rival families meet because of a missing lechon!',
      'A jeepney driver becomes a millionaire overnight!',
      'Two strangers end up at the same speed dating event!'
    ]
  }
};

export const OPPONENTS = [
  { id: 'diskarte', name: 'Diskarte Dan', elo: 420, emoji: '😎', style: 'street-smart, speaks in English with occasional Tagalog words like "pre", "grabe", "char", always has a clever unexpected angle' },
  { id: 'hugot', name: 'Hugot Hannah', elo: 380, emoji: '😢', style: 'speaks English but drops Tagalog hugot lines dramatically, connects everything to love and heartbreak' },
  { id: 'epal', name: 'Epal Edgar', elo: 310, emoji: '😤', style: 'speaks mostly English but inserts "naman", "talaga", "ano ba", loud and attention-seeking personality' },
  { id: 'seryoso', name: 'Seryoso Sam', elo: 290, emoji: '🤓', style: 'speaks formal English with occasional Filipino references, uses data and logic, very matter-of-fact' }
];

export const RANKS = [
  { name: 'Bata pa', emoji: '🥥', min: 0, max: 99, color: '#9b7ec8' },
  { name: 'Probinsyano', emoji: '🌺', min: 100, max: 299, color: '#00D4AA' },
  { name: 'Iskolar', emoji: '⚡', min: 300, max: 599, color: '#6C3BFF' },
  { name: 'Bayani', emoji: '🔥', min: 600, max: 999, color: '#FF5733' },
  { name: 'Alamat', emoji: '👑', min: 1000, max: 99999, color: '#FFD700' }
];

export function getRank(elo) {
  return RANKS.find(r => elo >= r.min && elo <= r.max) || RANKS[0];
}

export function buildMySystem(botName, style, instrux, mode, topic) {
  const base = `You are ${botName}, an AI bot competing in GalingBot, a Filipino battle app. Personality: ${style}. Extra rules: ${instrux || 'none'}. Topic/scenario: "${topic}". Speak in English but naturally mix in Filipino words like "pre", "grabe", "naman", "talaga", "char", "lodi", "sana all" — the way real Filipinos talk. Max 3 sentences. Be witty, punny, and fun. No offensive content.`;
  if (mode === 'banat') return base + ' Argue FOR the first option in the topic.';
  if (mode === 'tawad') return base + ' You are the BUYER. Haggle for the lowest price using creative arguments.';
  return base + ' Write a dramatic teleserye-style opening scene. Be kilig or intense.';
}

export function buildOppSystem(opp, mode, topic) {
  const base = `You are ${opp.name}, an AI bot in GalingBot. Personality: ${opp.style}. Topic: "${topic}". Speak in English but naturally mix in Filipino words — the way real Filipinos actually talk. Max 3 sentences. Be witty and fun. No offensive content.`;
  if (mode === 'banat') return base + ' Argue AGAINST the first option (for the second option). Respond directly to what your opponent just said.';
  if (mode === 'tawad') return base + ' You are the SELLER. Defend your price creatively and counter the buyer.';
  return base + ' Continue the story with a dramatic twist or conflict. Respond to the previous scene.';
}
